import { useState, useEffect } from 'react'

import { FestivalType, ShopbyFestivalComponents, ShopbyFestivalComponentAnchor } from '../../@types/aboutfishing'

interface FestivalAnchorNavigationProps {
  el: ShopbyFestivalComponents
  festivalData: FestivalType | null
  sectionRefs: React.MutableRefObject<Map<number | string, React.RefObject<HTMLDivElement>>>
}

const FestivalAnchorNavigation = ({ el, festivalData, sectionRefs }: FestivalAnchorNavigationProps) => {
  const [activeTab, setActiveTab] = useState<string>('')
  const [anchor, setAnchor] = useState<ShopbyFestivalComponentAnchor[] | null>(null)

  const getFixedHeight = () => {
    const headerWrap = document.querySelector('.header_wrap') as HTMLElement
    const anchorTab = document.querySelector('.anchor_tab') as HTMLElement
    return (headerWrap?.offsetHeight || 0) + (anchorTab?.offsetHeight || 0)
  }

  const getScrollPosition = (fixedHeight: number) => Math.round(window.scrollY + fixedHeight)

  const isSectionInView = (
    section: HTMLElement,
    scrollPosition: number,
    index: number,
    sections: NodeListOf<Element>
  ) => {
    const { offsetTop, offsetHeight } = section
    // 첫 번째 섹션 체크: 스크롤이 가장 위에 있거나 섹션이 화면에 보이면
    const isFirstSection = index === 0 && scrollPosition < offsetTop + offsetHeight / 2
    // 마지막 섹션 체크: 스크롤이 마지막 섹션 안에 있거나 그 이후로 내려갔을 때
    const isFinalSection = index === sections.length - 1 && scrollPosition >= offsetTop
    // 일반 섹션 체크: 스크롤이 섹션의 중간 위치에 있을 때
    const isCenterSection = scrollPosition > offsetTop && scrollPosition < offsetTop + offsetHeight
    return isFirstSection || isFinalSection || isCenterSection
  }

  //모바일도 그렇고 pc도 이 부분 때문에 마지막 탭 처리가 안됨
  // const isScreenBottom = () => {
  //   // 현재 스크롤 위치
  //   const scrollTop = window.scrollY || document.documentElement.scrollTop
  //   // 윈도우의 높이
  //   const windowHeight = window.innerHeight
  //   // 문서의 전체 높이
  //   const documentHeight = document.documentElement.scrollHeight
  //   // footer 높이
  //   const footerWrap = document.querySelector('.footer_wrap') as HTMLElement
  //   return !(scrollTop + windowHeight >= documentHeight - footerWrap?.clientHeight)
  // }

  const scrollHandler = () => {
    const sections = document.querySelectorAll('.section')
    const fixedHeight = getFixedHeight()
    let currentSectionId = ''

    sections.forEach((section, index) => {
      const scrollPosition = getScrollPosition(fixedHeight)

      if (isSectionInView(section as HTMLElement, scrollPosition, index, sections)) {
        currentSectionId = section.id
      }
    })
    setActiveTab(currentSectionId)
  }

  const scrollToSection = (id: number) => {
    const section = sectionRefs.current.get(id)
    if (section && section.current) {
      section.current.scrollIntoView()
    }
  }

  useEffect(() => {
    if (anchor) {
      window.addEventListener('scroll', scrollHandler)
      return () => {
        window.removeEventListener('scroll', scrollHandler)
      }
    }
  }, [anchor])

  useEffect(() => {
    if (festivalData) {
      const shopbyFestivalComponents = festivalData.festival.shopbyFestivalComponents
      const anchors = shopbyFestivalComponents
        .filter((element: ShopbyFestivalComponents) => element.type === 'anchor')
        .flatMap((element: ShopbyFestivalComponents) => element.shopbyFestivalComponentAnchors)
      if (anchors.length > 0) {
        setActiveTab(`section${anchors[0].componentId}`)
        setAnchor(anchors)
      }
    }
  }, [festivalData])

  return (
    <div className='anchor_tab' key={el.id} style={{ backgroundColor: `#${el.backgroundColor}` }}>
      <ul className={el.shopbyFestivalComponentAnchors.length >= 5 ? 'anchor_tab_wrap' : 'anchor_tab_wrap on'}>
        {el.shopbyFestivalComponentAnchors.map((element) => (
          <li key={element.componentId}>
            <button
              onClick={() => scrollToSection(element.componentId)}
              style={{
                border: 'none',
                color: `section${element.componentId}` === activeTab ? `#${el.clickedTextColor}` : `#${el.textColor}`,
                borderBottom: `section${element.componentId}` === activeTab ? `2px solid #${el.clickedColor}` : 'none',
              }}
            >
              {element.title}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default FestivalAnchorNavigation
